import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, SelectChangeEvent, Grid2 } from "@mui/material";
import { FilterList, FilterListOff } from "@mui/icons-material";
import { useState } from "react";

import { GenreFilterBody } from "@/api/types/genre";

export const defaultValues: Omit<GenreFilterBody, "skip" | "take"> = { search: "", category: null };

// eslint-disable-next-line no-unused-vars
export default function TagsFilters({ onApply }: { onApply: (data: typeof defaultValues) => void }) {
    const [fields, setFields] = useState(defaultValues);
    const [filterActivated, setFilterActivated] = useState<boolean>(false);

    const toggleFilters = () => setFilterActivated((prev) => !prev);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent) => {
        const name = event.target.name;
        const value = event.target.value;

        setFields((prev) => {
            return {
                ...prev,
                [name]: value,
            };
        });
    };

    const handleReset = () => {
        setFields(defaultValues);
        if (onApply) onApply(defaultValues);
    };

    const handleApply = () => onApply && onApply(fields);

    return (
        <Box className="filter-wrapper">
            {filterActivated && (
                <Box className="filter-fields-wrapper">
                    <Grid2 container className="filter-fields" spacing={2}>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                            <TextField
                                fullWidth
                                className="input field "
                                label="Search"
                                name="search"
                                placeholder="Enter some text"
                                size="small"
                                value={fields.search}
                                onChange={handleChange}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                            <FormControl fullWidth className="select field" size="small">
                                <InputLabel id="select-label">Category</InputLabel>
                                <Select
                                    id="select"
                                    label="Category"
                                    labelId="select-label"
                                    name="category"
                                    value={String(fields.category)}
                                    onChange={handleChange}
                                >
                                    <MenuItem value={null as any}>All</MenuItem>
                                    <MenuItem value="education">Education</MenuItem>
                                    <MenuItem value="entertainment">Entertainment</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                            <Grid2 container className="filter-actions" spacing={2}>
                                <Grid2 size={{ xs: 12, sm: 6 }}>
                                    <Button fullWidth className="action-btn" variant="contained" onClick={handleApply}>
                                        Apply
                                    </Button>
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6 }}>
                                    <Button fullWidth className="action-btn" variant="outlined" onClick={handleReset}>
                                        Reset
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Box>
            )}
            <Button
                startIcon={filterActivated ? <FilterListOff /> : <FilterList />}
                variant="contained"
                onClick={toggleFilters}
            >
                Filters
            </Button>
        </Box>
    );
}
